"use client";
import dynamic from "next/dynamic";
import React, { useEffect, useState } from "react";
const Button = dynamic(() => import("@/components/ui/Button"));
import Image from "next/image";
import { useRouter } from "next/navigation";
import { useAuth } from "@/contexts/authContext";
import { supabase } from "@/supabase/client";

const MXSAmount = () => {
  const { user, walletAddress } = useAuth();
  const router = useRouter();
  const [mxs, setMxs] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchMXS = async () => {
      if (!walletAddress) {
        setMxs(0);
        return;
      }
      setLoading(true);
      const { data, error } = await supabase
        .from("seasons_diff")
        .select("mxs")
        .eq("wallet_lc", walletAddress.toLowerCase())
        .single();
      if (data && typeof data.mxs !== "undefined") {
        setMxs(data.mxs);
      } else {
        setMxs(0);
      }
      setLoading(false);
    };
    fetchMXS();
  }, [walletAddress]);

  return (
    <>
      {user && (
        <div className="flex items-center justify-center">
          <Button
            onClick={() => {
              router.push("/seasons");
            }}
            className="shadow-sm focus:outline-none !ring-0 !ring-transparent !ring-offset-0 outline-none hover:outline-none btn-dark border-2 border-metaxseed-gray text-white text-xs lg:text-sm gothamMedium rounded-full px-2 py-1 sm:px-3 sm:py-2 flex items-center justify-center"
            style={{ margin: "0 8px" }}
          >
            <div className="flex items-center">
              <Image
                src="https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/branding%2Fmxs_games%2Fv1%2Fwhite%2Fpng%2Fmxs_icon_white.png?alt=media&token=8a7e36ba-954b-46b3-bcb2-559cec885bdf"
                className="w-6 h-6 mr-2"
                alt="MXS"
                width={24}
                height={24}
              />
              <span className="text-xs lg:text-sm flex items-center font-normal">
                {loading ? "..." : mxs}
                <span className="hidden lg:block ml-1 font-normal">MXS</span>
              </span>
            </div>
          </Button>
        </div>
      )}
    </>
  );
};

export default MXSAmount;
